import React, { JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { suggestionTypesKey } from './constants';

export interface KeywordsSuggestionProps {
    keywords?: string[];
    searchTerm?: string;
    selectedIndex?: number;
    onClick?: (value: string) => void;
    onHover?: (value: number) => void;
    onLeavingHover?: () => void;
    useNewSearchUI?: boolean;
}

// eslint-disable-next-line no-useless-escape
const specialKeywordMatchRegex = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi;

const KeywordsSuggestion = ({
    keywords = [],
    searchTerm = '',
    selectedIndex = -1,
    onClick = () => null,
    onHover = () => null,
    onLeavingHover = () => null,
    useNewSearchUI,
}: KeywordsSuggestionProps): JSX.Element | false => {
    return (
        !!keywords?.length && (
            <ul className="flex flex-col m-0 p-0 w-full" role="listbox" aria-label="Suggested searches">
                {keywords.map((keyword, index) => {
                    const cleanSearchTerm = searchTerm.replace(specialKeywordMatchRegex, '');
                    return (
                        <li
                            role="option"
                            aria-selected={index === selectedIndex}
                            tabIndex={-1}
                            id={`${suggestionTypesKey.KEYWORDS}${index}`}
                            key={index}
                            className={twMerge(
                                useNewSearchUI ? '-ml-3 pl-3 rounded-md' : 'px-4',
                                'cursor-pointer block text-sm font-normal leading-4 overflow-hidden py-2 text-ellipsis hover:bg-gray-100 w-full',
                                index === selectedIndex && useNewSearchUI && 'bg-gray-100',
                                index === selectedIndex &&
                                    !useNewSearchUI &&
                                    'bg-gray-100 border-solid border-2 border-blue-500',
                            )}
                            onClick={() => onClick(keyword)}
                            onKeyDown={() => onClick(keyword)}
                            onFocus={() => onHover(index)}
                            onMouseOver={() => onHover(index)}
                            onBlur={onLeavingHover}
                            onMouseOut={onLeavingHover}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: keyword.replace(new RegExp(cleanSearchTerm, 'i'), '<b>$&</b>'),
                                }}
                            />
                        </li>
                    );
                })}
            </ul>
        )
    );
};

export default KeywordsSuggestion;
